// mobile
import mobile from "../views/Mobile/mobileIndex";
import mobileMenu from "../views/Mobile/Menu/list";
import secondMobileMenu from "../views/Mobile/Menu/secondlist";
import warehouse from "../views/Mobile/Warehouse/warehouse";

import signIn from "../views/Mobile/SignIn/signIn";
import signInDetail from "../views/Mobile/SignIn/signInDetail";

import putaway from "../views/Mobile/Putaway/putaway";
import putawayDetail from "../views/Mobile/Putaway/putawayDetail";
import putawayConfirm from "../views/Mobile/Putaway/putawayConfirm";

import stock from "../views/Mobile/Stock/stock";
import inventory from "../views/Mobile/Inventory/inventory";
import changeInventory from "../views/Mobile/Inventory/changeInventory";
import pickingIndex from "../views/Mobile/Picking/pickingIndex";
import picking from "../views/Mobile/Picking/picking";
import pickingContainer from "../views/Mobile/Picking/pickingContainer";
import pickingDetail from "../views/Mobile/Picking/pickingDetail";

import baleIndex from "../views/Mobile/Bale/baleIndex";
import bale from "../views/Mobile/Bale/bale";
import baleSingleSku from "../views/Mobile/Bale/baleSingleSku";
import baleMoreSku from "../views/Mobile/Bale/baleMoreSku";

import recheck from "../views/Mobile/Recheck/recheck";
import recheckList from "../views/Mobile/Recheck/recheckList";
import recheckDetail from "../views/Mobile/Recheck/recheckDetail";
import recheckindex from "../views/Mobile/Recheck/recheckindex";
import labeling from "../views/Mobile/Labeling/labeling";
import labelingList from "../views/Mobile/Labeling/labelingList";
import labelingDetail from "../views/Mobile/Labeling/labelingDetail";
import labelingindex from "../views/Mobile/Labeling/labelingindex";
import loading from "../views/Mobile/Loading/loading";
import loadingList from "../views/Mobile/Loading/loadingList";
import loadingDetail from "../views/Mobile/Loading/loadingDetail";
import loadingindex from "../views/Mobile/Loading/loadingindex";
import rePutaway from "../views/Mobile/RePutaway/rePutaway";
import rePutawayDetail from "../views/Mobile/RePutaway/rePutawayDetail";
import changelabel from "../views/Mobile/Changelabel/Changelabel";
import ChangelabelDetail from "../views/Mobile/Changelabel/ChangelabelDetail";

import OtherExWarehouse from "../views/Mobile/StockIO/OtherExWarehouse";//其他出库列表
import OtherExWarehouseDetail from "../views/Mobile/StockIO/OtherExWarehouseDetail";//其他出库详情
import otherInStock from "../views/Mobile/StockIO/otherInStock";//其他入库
import otherInStockDetail from "../views/Mobile/StockIO/otherInStockDetail";//其他入库明细
import JySignReceipt from "../views/Mobile/JySignReceipt/jy-signReceipt";
import JySignReceiptDetail from "../views/Mobile/JySignReceipt/jy-signReceiptDetail2";

import JyReceiptGoods from "../views/Mobile/JyReceiptGoods/jy-receiptGoods";
import JyReceiptGoodsDetail from "../views/Mobile/JyReceiptGoods/jy-receiptGoodsDetail";
import JyOnTheShelves from "../views/Mobile/JyOnTheShelves/jy-onTheShelves";
import JyOnTheShelvesDetail from "../views/Mobile/JyOnTheShelves/jy-onTheShelvesDetail";
import JyValueAddedServices from "../views/Mobile/JyValueAddedServices/jy-valueAddedServices";
import JyValueAddedServicesDetail from "../views/Mobile/JyValueAddedServices/jy-valueAddedServicesDetail";
import JyChangeInventory from "../views/Mobile/JyChangeInventory/jy-changeInventory";
import JyInventoryInfo from "../views/Mobile/JyInventoryInfo/jy-inventoryInfo";
import JyPalletPutOn from "../views/Mobile/JyPalletPutOn/jy-palletPutOn";
import JyPalletPutOnList from "../views/Mobile/JyPalletPutOn/jy-palletPutOnList";
import JyOutboundPick from "../views/Mobile/JyOutboundPick/jy-outboundPick";
import JyOutboundPickDetail from "../views/Mobile/JyOutboundPick/jy-outboundPickDetail";
import JyOutboundPickDetail2 from "../views/Mobile/JyOutboundPick/jy-outboundPickDetail2";
import JyOutboundPickSend from "../views/Mobile/JyOutboundPick/jy-outboundPickSend";
import JyFastSearch from "../views/Mobile/JyFastSearch/jy-fastSearch";
import JyOutbound from "../views/Mobile/JyOutbound/jy-outbound";
import JyArrive from "../views/Mobile/JyArrive/jy-arrive";
import JyOutboundScan from "../views/Mobile/JyOutbound/jy-outboundScan";
import JyOutboundDetail from "../views/Mobile/JyOutbound/jy-outboundDetail";
import JyOutboundScanDetail from "../views/Mobile/JyOutbound/jy-outboundScanDetail";
import JyOutboundScanDetail2 from "../views/Mobile/JyOutbound/jy-outboundScanDetail2";
import JyOutboundBoxList from "../views/Mobile/JyOutbound/jy-outboundBoxList";
import JyOutboundScanBoxList from "../views/Mobile/JyOutbound/jy-outboundScanBoxList";

// mobile reserve
import mobileReserve from "../views/Mobile_Reserve/reserveIndex";
import reserveItems from "../views/Mobile_Reserve/ReserveItems/reserveItems";
import appointmentDelivery from "../views/Mobile_Reserve/AppointmentDelivery/appointmentDelivery";
import appointmentDeliveryBatch from "../views/Mobile_Reserve/AppointmentDelivery/appointmentDeliveryBatch";
import appointmentDetail from "../views/Mobile_Reserve/AppointmentDelivery/appointmentDetail";
import appointmentSearch from "../views/Mobile_Reserve/AppointmentSearch/appointmentSearch";
import appointmentCheck from "../views/Mobile_Reserve/AppointmentDelivery/appointmentCheck";
import appointmentArrive from "../views/Mobile_Reserve/AppointmentDelivery/appointmentArrive";

export const MOBILE_ROUTER = [
    {
        path: "/mobile/index",
        name: "mobile",
        component: mobile,
        meta: {
            title: '中转仓移动端',
            NoTabPage: true,
            NoNeedHome: true,
            requireAuth: true
        },
        hidden: true,
        children: [
            {
                path: '/mobile/mobileMenu',
                component: mobileMenu,
                meta: {
                    title: '操作菜单',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/warehouse',
                component: warehouse,
                meta: {
                    title: '选择仓库',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/secondMobileMenu',
                component: secondMobileMenu,
                meta: {
                    title: '库内操作',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/OtherExWarehouse',
                component: OtherExWarehouse,
                meta: {
                    title: '其他出库',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/OtherExWarehouseDetail',
                component: OtherExWarehouseDetail,
                meta: {
                    title: '其他出库',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },

            {
                path: '/mobile/otherInStock',
                component: otherInStock,
                meta: {
                    title: '其他入库',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },

            {
                path: '/mobile/otherInStockDetail',
                component: otherInStockDetail,
                meta: {
                    title: '其他入库-签收',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/signIn',
                component: signIn,
                meta: {
                    title: '签收',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true,
                    keepAlive: true
                },
            },
            {
                path: '/mobile/signInDetail',
                component: signInDetail,
                meta: {
                    title: '签收',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/putaway',
                component: putaway,
                meta: {
                    title: '上架任务',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true,
                    keepAlive: true
                },
            },
            {
                path: '/mobile/putawayDetail',
                component: putawayDetail,
                meta: {
                    title: '上架',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/putawayConfirm',
                component: putawayConfirm,
                meta: {
                    title: '确认上架',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/stock',
                component: stock,
                meta: {
                    title: '库存查询',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/inventory',
                component: inventory,
                meta: {
                    title: '盘点',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/changeInventory',
                component: changeInventory,
                meta: {
                    title: '移库操作',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/changelabel',
                component: changelabel,
                meta: {
                    title: '换标操作',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/ChangelabelDetail',
                component: ChangelabelDetail,
                meta: {
                    title: '换标操作',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/pickingIndex',
                component: pickingIndex,
                meta: {
                    title: '拣货',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/picking',
                component: picking,
                meta: {
                    title: '拣货',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/pickingContainer',
                component: pickingContainer,
                meta: {
                    title: '拣货',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/pickingDetail',
                component: pickingDetail,
                meta: {
                    title: '拣货',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/baleIndex',
                component: baleIndex,
                meta: {
                    title: '打包',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/bale',
                component: bale,
                meta: {
                    title: '打包',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/baleSingleSku',
                component: baleSingleSku,
                meta: {
                    title: '打包',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/baleMoreSku',
                component: baleMoreSku,
                meta: {
                    title: '打包',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/recheck',
                component: recheck,
                meta: {
                    title: '复核',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/recheckList',
                component: recheckList,
                meta: {
                    title: '复核',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/recheckDetail',
                component: recheckDetail,
                meta: {
                    title: '复核',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/recheckindex',
                component: recheckindex,
                meta: {
                    title: '复核',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/labeling',
                component: labeling,
                meta: {
                    title: '备柜',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/labelingList',
                component: labelingList,
                meta: {
                    title: '备柜',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/labelingDetail',
                component: labelingDetail,
                meta: {
                    title: '备柜',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/labelingindex',
                component: labelingindex,
                meta: {
                    title: '备柜',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },

            {
                path: '/mobile/loadingindex',
                component: loadingindex,
                meta: {
                    title: '装车',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/loading',
                component: loading,
                meta: {
                    title: '装车',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/loadingList',
                component: loadingList,
                meta: {
                    title: '装车',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/loadingDetail',
                component: loadingDetail,
                meta: {
                    title: '装车',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/rePutaway',
                component: rePutaway,
                meta: {
                    title: '重新上架',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/rePutawayDetail',
                component: rePutawayDetail,
                meta: {
                    title: '重新上架',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/jy-signReceipt',
                component: JySignReceipt,
                meta: {
                    title: '集运-签收',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true,
                },
            },
            {
                path: '/mobile/jy-signReceiptDetail2',
                component: JySignReceiptDetail,
                meta: {
                    title: '集运-签收',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/jy-receiptGoods',
                component: JyReceiptGoods,
                meta: {
                    title: '集运-收货',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true,
                },
            },
            {
                path: '/mobile/jy-receiptGoodsDetail',
                component: JyReceiptGoodsDetail,
                meta: {
                    title: '集运-收货',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/jy-onTheShelves',
                component: JyOnTheShelves,
                meta: {
                    title: '集运-上架',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true,
                },
            },
            {
                path: '/mobile/jy-onTheShelvesDetail',
                component: JyOnTheShelvesDetail,
                meta: {
                    title: '集运-上架',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/jy-valueAddedServices',
                component: JyValueAddedServices,
                meta: {
                    title: '集运-增值服务',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true,
                },
            },
            {
                path: '/mobile/jy-valueAddedServicesDetail',
                component: JyValueAddedServicesDetail,
                meta: {
                    title: '集运-增值服务',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/jy-outboundPick',
                component: JyOutboundPick,
                meta: {
                    title: '集运-拣货',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true,
                },
            },
            {
                path: '/mobile/jy-outboundPickDetail',
                component: JyOutboundPickDetail,
                meta: {
                    title: '集运-拣货',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/jy-outboundPickDetail2',
                component: JyOutboundPickDetail2,
                meta: {
                    title: '集运-备货',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/jy-outboundPickSend',
                component: JyOutboundPickSend,
                meta: {
                    title: '集运-备货出库',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/jy-outbound',
                component: JyOutbound,
                meta: {
                    title: '集运-出库',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true,
                },
            },
            {
                path: '/mobile/jy-arrive',
                component: JyArrive,
                meta: {
                    title: '集运-到仓查询',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true,
                },
            },
            {
                path: '/mobile/jy-outboundScan',
                component: JyOutboundScan,
                meta: {
                    title: '集运-箱唛出库',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true,
                },
            },
            {
                path: '/mobile/jy-outboundDetail',
                component: JyOutboundDetail,
                meta: {
                    title: '集运-出库',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/jy-outboundScanDetail',
                component: JyOutboundScanDetail,
                meta: {
                    title: '集运-箱唛出库',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/jy-outboundScanDetail2',
                component: JyOutboundScanDetail2,
                meta: {
                    title: '集运-出库拍照',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/jy-outboundBoxList',
                component: JyOutboundBoxList,
                meta: {
                    title: '集运-出库',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/jy-outboundScanBoxList',
                component: JyOutboundScanBoxList,
                meta: {
                    title: '集运-装车详情',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true
                },
            },
            {
                path: '/mobile/jy-changeInventory',
                component: JyChangeInventory,
                meta: {
                    title: '集运-移库',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true,
                },
            },
            {
                path: '/mobile/jy-inventoryInfo',
                component: JyInventoryInfo,
                meta: {
                    title: '集运-盘点',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true,
                },
            },
            {
                path: '/mobile/jy-palletPutOn',
                component: JyPalletPutOn,
                meta: {
                    title: '集运-托盘上架',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true,
                },
            },
             {
                path: '/mobile/jy-palletPutOnList',
                component: JyPalletPutOnList,
                meta: {
                    title: '集运-托盘列表',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true,
                },
            },
            {
                path: '/mobile/jy-fastSearch',
                component: JyFastSearch,
                meta: {
                    title: '集运-快速搜索',
                    NoTabPage: true,
                    NoNeedHome: true,
                    requireAuth: true,
                },
            },
        ],
        redirect: '/mobile/warehouse'
    },
    {
        path: "/mobile/reserve",
        name: "mobileReserve",
        component: mobileReserve,
        meta: {
            title: '预约',
            NoTabPage: true,
            NoNeedHome: true
        },
        hidden: true,
        children: [
            {
                path: '/mobile/reserveItems',
                component: reserveItems,
                meta: {
                    title: '预约送货',
                    NoTabPage: true,
                    NoNeedHome: true
                },
            },
            {
                path: '/mobile/appointmentDelivery',
                component: appointmentDelivery,
                meta: {
                    title: '预约送货',
                    NoTabPage: true,
                    NoNeedHome: true,
                    keepAlive: true
                },
            },
            {
                path: '/mobile/appointmentArrive',
                component: appointmentArrive,
                meta: {
                    title: '到仓证明',
                    NoTabPage: true,
                    NoNeedHome: true,
                    keepAlive: true
                },
            },
            {
                path: '/mobile/appointmentDeliveryBatch',
                component: appointmentDeliveryBatch,
                meta: {
                    title: '批量预约',
                    NoTabPage: true,
                    NoNeedHome: true,
                    keepAlive: true
                },
            },
            {
                path: '/mobile/appointmentDetail',
                component: appointmentDetail,
                meta: {
                    title: '提交预约',
                    NoTabPage: true,
                    NoNeedHome: true
                },
            },
            {
                path: '/mobile/appointmentSearch',
                component: appointmentSearch,
                meta: {
                    title: '查询预约单',
                    NoTabPage: true,
                    NoNeedHome: true
                },
            },
            {
                path: '/mobile/appointmentCheck',
                component: appointmentCheck,
                meta: {
                    title: '办单核收',
                    NoTabPage: true,
                    NoNeedHome: true
                },
            },
        ],
        redirect: '/mobile/reserveItems'
    }
]